// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7655":"3e3c295d6d65caf3","9038":"2cb05b66999736b9"}[chunkId] + ".js";
};